import { useEffect, useState } from 'react'

import type { ShowResolvedState } from '../types'

const showResolvedKey = 'show_resolved_threads'

// todo: remove it in OCT-4153
export const useShowResolvedState = (): ShowResolvedState => {
  const [showResolved, setState] = useState(false)

  useEffect(() => {
    const storedValue = localStorage.getItem(showResolvedKey)
    setShowResolved(Boolean(storedValue))
  }, [])

  const setShowResolved = (next: boolean) => {
    const nextValue = next ? 'true' : ''
    localStorage.setItem(showResolvedKey, nextValue)

    setState(next)
  }

  return { setShowResolved, showResolved }
}
